module.exports = __webpack_public_path__ + "img/dizhi.97ff788a.png";